/* eslint-disable-next-line */
export interface WebShippingProps {}

export function WebShipping(props: WebShippingProps) {
  return (
    <div>
      <h1>Welcome to WebPlaShipping!</h1>
    </div>
  );
}

export default WebShipping;
